import VueApexCharts from 'vue3-apexcharts';
/**
 * Initialize VueApexChart component
 * @param app vue instance
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function initApexCharts(app) {
    app.use(VueApexCharts);
}
